import React, { useState } from "react"
import Breadcrumbs2 from "components/Common/Breadcrumb2"
import {
  Button,
  Card,
  CardBody,
  CloseButton,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
} from "reactstrap"
import { useDispatch, useSelector } from "react-redux"
import { useFormik } from "formik"
import * as Yup from "yup"
import CompanyAction from "store/company-resource/actions"
import { MetaTags } from "react-meta-tags"
import Skeleton from "react-loading-skeleton"
import TableContainer from "components/newTables/TableContainer"

export default function EnterpriseCompany() {
  const dispatch = useDispatch()

  const store = useSelector(state => state.company)
  const [isFull, setIsFull] = React.useState(true)
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })
  const [params, setParams] = React.useState({
    page: 0,
    size: 10,
  })
  console.log("params")
  console.log(params)

  const [formState, setFormState] = React.useState("add")
  const [id, setId] = React.useState("")

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: "",
      code: "",
      bettingRate: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("必須項目です。"),
      code: Yup.string().required("必須項目です。"),
      bettingRate: Yup.string().required("必須項目です。"),
    }),
    onSubmit: values => {
      if (formState === "add") {
        dispatch(CompanyAction.postData(values, callbackPost))
      } else {
        dispatch(
          CompanyAction.putData(
            {
              ...values,
              id,
            },
            callbackPut
          )
        )
      }
    },
  })

  const callbackPost = () => {
    dispatch(CompanyAction.getListPages(params))
    setIsFull(false)
    validation.resetForm()
  }

  const callbackGetDetail = data => {
    setIsFull(false)
    setFormState("edit")
    setId(data.id)
    validation.setValues(data)
  }

  const callbackPut = () => {
    dispatch(CompanyAction.getListPages(params))
    setIsFull(false)
    setId("")
    setFormState("add")
    validation.resetForm()
  }

  React.useEffect(() => {
    dispatch(CompanyAction.getListPages({ ...params, ...pagination }))
  }, [params, pagination])

  const columns = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "id",
        disableSortBy: true,
      },
      {
        Header: "企業名",
        accessor: "name",
        disableSortBy: true,
      },
      {
        Header: "コード",
        accessor: "code",
        disableSortBy: true,
      },

      {
        Header: "掛け率",
        accessor: "bettingRate",
        disableSortBy: true,
      },

      {
        Header: "編集",
        accessor: "action",
        disableSortBy: true,
        Cell: ({ cell }) => {
          return (
            <span
              role="button"
              className="text-primary"
              onClick={() => {
                dispatch(
                  CompanyAction.getDetail(
                    { id: cell.row.original.id },
                    callbackGetDetail
                  )
                )
              }}
            >
              編集
            </span>
          )
        },
      },
    ],
    []
  )

  return (
    <>
      <MetaTags>
        <title>取引先企業管理 | Igarashi Trousers</title>
      </MetaTags>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs2 title="取引先企業管理" breadcrumbItems={[]} />

          <Row>
            <Col sm="12" md={isFull ? "12" : "6"}>
              <Card>
                <CardBody>
                  <Row className="mb-3">
                    <Col sm="6" />
                    <Col sm="6" className="gap-3 justify-content-end d-flex">
                      <Button
                        className="button"
                        onClick={() => {
                          setIsFull(false)
                          setFormState("add")
                          validation.setValues({
                            code: "",
                            name: "",
                            bettingRate: "0",
                          })
                        }}
                      >
                        会社を追加
                      </Button>
                    </Col>
                  </Row>
                  <Row className="mb-2">
                    {store.company.loading ? (
                      <Skeleton count={5} />
                    ) : !store.company.data?.content?.length ? (
                      <p>Resource not found</p>
                    ) : (
                      <TableContainer
                        data={store.company.data?.content || []}
                        columns={columns}
                        pagination
                        page={pagination.page}
                        size={pagination.size}
                        count={store.company.data?.totalPages || 1}
                        params={pagination}
                        setParams={setPagination}
                      />
                    )}
                  </Row>
                </CardBody>
              </Card>
            </Col>
            {!isFull && (
              <Col sm="12" md="6">
                <Card>
                  <CardBody>
                    <div className="d-flex justify-content-end">
                      <CloseButton onClick={() => setIsFull(true)} />
                    </div>
                    <Form
                      className="form-horizontal"
                      onSubmit={e => {
                        e.preventDefault()
                        validation.handleSubmit()
                        return false
                      }}
                    >
                      <div className="mb-3">
                        <Label className="form-label">企業名</Label>
                        <Input
                          name="name"
                          className="form-control"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.name || ""}
                          invalid={
                            validation.touched.name && validation.errors.name
                              ? true
                              : false
                          }
                        />
                        {validation.touched.name && validation.errors.name ? (
                          <FormFeedback type="invalid">
                            {validation.errors.name}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">コード</Label>
                        <Input
                          name="code"
                          value={validation.values.code || ""}
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.code && validation.errors.code
                              ? true
                              : false
                          }
                        />
                        {validation.touched.code && validation.errors.code ? (
                          <FormFeedback type="invalid">
                            {validation.errors.code}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mb-3">
                        <Label className="form-label">掛け率</Label>

                        <InputGroup>
                          <Input
                            name="bettingRate"
                            value={validation.values.bettingRate || ""}
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            invalid={
                              validation.touched.bettingRate &&
                              validation.errors.bettingRate
                                ? true
                                : false
                            }
                          />
                          <InputGroupText>%</InputGroupText>
                        </InputGroup>

                        {validation.touched.bettingRate &&
                        validation.errors.bettingRate ? (
                          <FormFeedback type="invalid">
                            {validation.errors.bettingRate}
                          </FormFeedback>
                        ) : null}
                      </div>

                      <div className="mt-3 text-end">
                        <button className="btn button px-5" type="submit">
                          保存
                        </button>
                      </div>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>
      </div>
    </>
  )
}
